import React from 'react';

import Accordion, { AccordionProps } from 'Components/Accordion';

import { Wrapper, Heading, Type, Location, Anchor } from './Event.styled';

export interface Props extends Omit<AccordionProps, 'heading'> {
    heading: string;
    type?: string;
    location?: string;
}

const Event: React.FC<Props> = props => {
    const { id, heading, type, location, ...rest } = props;

    return (
        <Accordion
            id={id}
            className={`c-event-accordion ${type ? `c-event-accordion-${type}` : ''}`
                .toLowerCase()
                .trim()}
            {...rest}
            heading={
                <>
                    <Anchor id={id} />
                    <Wrapper>
                        <Heading>
                            {heading} {type && <Type>{type}</Type>}
                        </Heading>
                        {location && <Location>{location}</Location>}
                    </Wrapper>
                </>
            }
        />
    );
};

export default Event;
